export default {"src":"/_next/static/media/Close.477c479b.svg","height":14,"width":14};